<template>
    <div class="HeadLogo">
      <img src="@/assets/headLogo.png">
    </div>
</template>
<script>
    export default {
  name: "crumbs",
  props:{},
  data() {
    return {
      List:[]
    }
  }
}
</script>
<style scoped>
  .HeadLogo,
  .HeadLogo img{
    width:100%;
  }
</style>
